import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#C11B1B" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            <CFLink href="https://www.facebook.com/profile.php?id=1367423400067948">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sakeya Sushi Facebook"
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/88-palpal-noodle-house-burnaby">
              <CFImage w="40px" pr="10px" src={yelp} alt="Sakeya Sushi Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/88-palpal-noodle-house-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sakeya Sushi Zomato"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/sakeya_sushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sakeya Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#C11B1B" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink href="https://www.facebook.com/profile.php?id=1367423400067948">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Sakeya Sushi Facebook"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.yelp.ca/biz/88-palpal-noodle-house-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={yelp}
                alt="Sakeya Sushi Yelp"
                hover
              />
            </CFLink>
            <CFLink href="https://www.zomato.com/vancouver/88-palpal-noodle-house-central-burnaby-burnaby">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Sakeya Sushi Zomato"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/sakeya_sushi/">
              <CFImage
                w="40px"
                pr="10px"
                src={instagram}
                alt="Sakeya Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
